module.exports = __webpack_public_path__ + "img/451082.2b792c32.png";